import { Trans } from 'react-i18next';
import IconBank from './assets/bank.svg';
import IconGlobal from './assets/global.svg';
import IconScramble from './assets/scramble.svg';
import { EMPTY_DASH } from '@/helpers/constants';
import { MyLink } from '@/components/MyLink';

export const CARDS = (t, data) => [
  {
    id: 'bank_deposit',
    label: t('inv_types.bank_deposit'),
    value: data?.bank_deposit ? `~${data?.bank_deposit}%` : EMPTY_DASH,
    icon: IconBank,
    iconSize: { width: 36, height: 36 },
    description: (
      <Trans
        i18nKey="inv_types.bank_deposit_description"
        ns="calculator"
        components={{
          Link: (
            <MyLink
              isExternal
              newWindow
              underline
              href="https://www.ecb.europa.eu/stats/financial_markets_and_interest_rates/bank_interest_rates/mfi_interest_rates/html/index.en.html"
            />
          ),
        }}
      />
    ),
  },
  {
    id: 'global_stocks',
    label: t('inv_types.global_stocks'),
    value: data?.global_stocks ? `~${data?.global_stocks}%` : EMPTY_DASH,
    icon: IconGlobal,
    iconSize: { width: 36, height: 36 },
    description: (
      <Trans
        i18nKey="inv_types.global_stocks_description"
        ns="calculator"
        components={{
          Link: (
            <MyLink
              isExternal
              newWindow
              underline
              href="https://www.msci.com/indexes/index/990100"
            />
          ),
        }}
      />
    ),
  },
  {
    id: 'scramble',
    label: '',
    value: data?.scramble_irr ? `${data.scramble_irr}%` : EMPTY_DASH,
    icon: IconScramble,
    iconSize: { width: 100, height: 20 },
    description: t('inv_types.scramble_description'),
  },
];